<template>
  <div id="main" class="main">
    <Nav :agenciesForSearch="agencies" class="navbar" search="true" />
    <div class="content-container">
      <h2>About the site</h2>
      <p>This site was created by <a href="https://twitter.com/chrisarvinsf" target="_blank">Chris Arvin</a> and <a href="https://twitter.com/katsiegal" target="_blank">Kat Siegal</a> to track levels of public transit service and ridership activity after the COVID-19 pandemic. Email <a href="mailto:transitrecovery.com@gmail.com">transitrecovery.com@gmail.com</a> to get in touch.</p>
      <h2>About the data</h2>
      <p>Data is provided by the Federal Transit Administration's <a href="https://www.transit.dot.gov/ntd" target="_blank">National Transit Database.</a> Transit agencies that meet certain criteria self-report their data on vehicle service hours and unlinked passenger trips to the FTA on a monthly basis. There is 1.5 to 2 month lag in the data.</p>
      <p>We are using the &quot;vehicle revenue hours&quot; data – the total number of hours traveled by all transit vehicles while providing service – to determine the amount of service provided. Ridership activity is determined by &quot;unlinked passenger trips&quot; – essentially, counted each time a passenger boards any transit vehicle.</p>
      <h2>Data considerations</h2>
      <ul>
        <li>Due to the on-demand nature of some transit operations, Demand-Response and Vanpool transit operations are excluded from the data. This includes paratransit.</li>
        <li>Monthly numbers are normalized to account for the number of days in a month. There still will be some slight discrepancies when comparing months due to holidays and a varying number of weekend days in a month.</li>
        <li>Agency size is measured by the number of unlinked passenger trips before the pandemic. Agencies are split into four class sizes using a Jenks natural breaks classification.</li>
        <li>When comparing values, &quot;before the pandemic&quot; refers to the average amount of transit service or ridership in January 2020 and February 2020.</li>
      </ul>
    </div>
  </div>
</template>

<script>
import Nav from './Nav.vue'
import * as cacheValue from '../util/cache-value.js'

export default {
  name: 'AboutPage',
  data() {
    return {
      agencies: []
    }
  },
  components: {
    Nav
  },
  mounted() {
    fetch('https://ntd-monthly.storage.googleapis.com/agencies-shallow.json?v' + cacheValue())
      .then(response => response.json())
      .then(data => (this.agencies = data))
  }
}
</script>

<style>

.main {
  width: 100%;
  text-align: left;
}

.navbar {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 1200;
}

h2 {
  margin-bottom: 6px;
  margin-top: 32px;
}

.main p {
  margin-bottom: 24px;
}

li {
  line-height: 1.8em;
}

ul {
  margin-bottom: 72px;
}
</style>
